import { createContext } from "react";

const CompanyFactorScreen = createContext<any>(null);

export default CompanyFactorScreen;
